import React, { useEffect } from 'react'
import '../CSS/common.css'

const Homepage = () => {
  useEffect(() => {
    console.log("Homepage JS");
  }, [])
  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" , flexDirection:"column" }}>
      <img src='/ec-logo-wt.png' />
      <div>
        Welcome To Enlightened Circle Central Repository
      </div>
    </div>
  )
}

export default Homepage